import axios from 'axios'
import store from '@/store'
import router from '@/router'
// import i18n from '@/plugins/vue-i18n'

const $http = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

$http.interceptors.request.use((config) => {
  const token = store.getters.getToken
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, (err) => {
  return Promise.reject(err)
})

$http.interceptors.response.use((response) => { // intercept the global error
  return response
}, async (err) => {
  if (err.response.status === 401) {
    await store.dispatch('logoutUser')
    router.push('/login')
  }
  return Promise.reject(err)
})

export { $http }
